export const coursesData = [
  {
    id: 1,
    title: 'آشنایی با معماری',
    teacherName: 'افشین زنگنه',
    teacherImgSrc: 'https://randomuser.me/api/portraits/men/51.jpg',
    imgSrc:
      'https://process.filepicker.io/APHE465sSbqvbOIStdwTyz/rotate=deg:exif/resize=fit:crop,height:283,width:472/output=quality:80,compress:true,strip:true,format:jpg/cache=expiry:max/https://cdn.filestackcontent.com/TcAWV8mZShCS36mN0Uei',
    rate: 4.5,
  },
  {
    id: 2,
    title: 'شطرنج برای مبتدیان',
    teacherName: 'مرتضی شهرابی فراهانی',
    teacherImgSrc: 'https://randomuser.me/api/portraits/men/31.jpg',
    imgSrc:
      'https://process.filepicker.io/APHE465sSbqvbOIStdwTyz/rotate=deg:exif/resize=fit:crop,height:283,width:472/output=quality:80,compress:true,strip:true,format:jpg/cache=expiry:max/https://cdn.filestackcontent.com/bCpGofJTliqN6MltJhvQ',
    rate: 5,
  },
  {
    id: 3,
    title: 'کارهای عجیب حیوانات',
    teacherName: 'محمد مهدی جاوید',
    teacherImgSrc: 'https://randomuser.me/api/portraits/men/43.jpg',
    imgSrc:
      'https://process.filepicker.io/APHE465sSbqvbOIStdwTyz/rotate=deg:exif/resize=fit:crop,height:283,width:472/output=quality:80,compress:true,strip:true,format:jpg/cache=expiry:max/https://cdn.filestackcontent.com/MRHy9ejOR8u4FdyzxeXo',
    rate: 4,
  },
  {
    id: 4,
    title: 'تندخوانی',
    teacherName: 'غزل بخشنده',
    teacherImgSrc: 'https://randomuser.me/api/portraits/women/65.jpg',
    imgSrc:
      'https://process.filepicker.io/APHE465sSbqvbOIStdwTyz/rotate=deg:exif/resize=fit:crop,height:283,width:472/output=quality:80,compress:true,strip:true,format:jpg/cache=expiry:max/https://cdn.filestackcontent.com/dAqePyb4R5CQN1FfEHcZ',
    rate: 4.5,
  },
  {
    id: 5,
    title: 'مقدمات زبان چینی',
    teacherName: 'بیان دیوانی آذر',
    teacherImgSrc: 'https://randomuser.me/api/portraits/women/13.jpg',
    imgSrc:
      'https://process.filepicker.io/APHE465sSbqvbOIStdwTyz/rotate=deg:exif/resize=fit:crop,height:283,width:472/output=quality:80,compress:true,strip:true,format:jpg/cache=expiry:max/https://cdn.filestackcontent.com/6Y5fDn6BT86JdxU5ei3H',
    rate: 5,
  },
  {
    id: 6,
    title: 'آموزش گیتار برای کودکان',
    teacherName: 'دانیال بازمانده',
    teacherImgSrc: 'https://randomuser.me/api/portraits/men/3.jpg',
    imgSrc:
      'https://process.filepicker.io/APHE465sSbqvbOIStdwTyz/rotate=deg:exif/resize=fit:crop,height:283,width:472/output=quality:80,compress:true,strip:true,format:jpg/cache=expiry:max/https://cdn.filestackcontent.com/KeX9jdVyT8CHvIW3xX46',
    rate: 4,
  },
  {
    id: 7,
    title: 'نویسندگی خلاقانه',
    teacherName: 'حانیه جعفری',
    teacherImgSrc: 'https://randomuser.me/api/portraits/women/81.jpg',
    imgSrc:
      'https://process.filepicker.io/APHE465sSbqvbOIStdwTyz/rotate=deg:exif/resize=fit:crop,height:283,width:472/output=quality:80,compress:true,strip:true,format:jpg/cache=expiry:max/https://cdn.filestackcontent.com/nNTBArS9S2i2PMEEWJOf',
    rate: 4.5,
  },
  {
    id: 8,
    title: 'هم خوانی تاریخچه سیاه‌پوستان',
    teacherName: 'سید عماد موسوی',
    teacherImgSrc: 'https://randomuser.me/api/portraits/men/44.jpg',
    imgSrc:
      'https://process.filepicker.io/APHE465sSbqvbOIStdwTyz/rotate=deg:exif/resize=fit:crop,height:283,width:472/output=quality:80,compress:true,strip:true,format:jpg/cache=expiry:max/https://cdn.filestackcontent.com/hCA3gbjSmmGBEkbJw7ON',
    rate: 5,
  },
  {
    id: 9,
    title: 'نقاشی دایناسور',
    teacherName: 'باوان دیوانی آذر',
    teacherImgSrc: 'https://randomuser.me/api/portraits/women/84.jpg',
    imgSrc:
      'https://process.filepicker.io/APHE465sSbqvbOIStdwTyz/rotate=deg:exif/resize=fit:crop,height:283,width:472/output=quality:80,compress:true,strip:true,format:jpg/cache=expiry:max/https://cdn.filestackcontent.com/gq9LQG5Q2ijS4clk19sg',
    rate: 3.5,
  },
  {
    id: 10,
    title: 'سخنرانی در جمع',
    teacherName: 'علی صداقی',
    teacherImgSrc: 'https://randomuser.me/api/portraits/men/42.jpg',
    imgSrc:
      'https://process.filepicker.io/APHE465sSbqvbOIStdwTyz/rotate=deg:exif/resize=fit:crop,height:283,width:472/output=quality:80,compress:true,strip:true,format:jpg/cache=expiry:max/https://cdn.filestackcontent.com/7MNa1W9jSyKYoKW5MMUl',
    rate: 4.5,
  },
  {
    id: 11,
    title: 'پول چگونه کار می‌کند؟',
    teacherName: 'مصطفی حسینی',
    imgSrc: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTV0mQCKMGXZWdk6A63KcO1ZbtTDb4fwlCwfg&usqp=CAU',
    teacherImgSrc: 'https://randomuser.me/api/portraits/men/76.jpg',
    rate: 4,
  },
];
